/* eslint-disable react-hooks/exhaustive-deps */
/* รายการใบเลือกวัสดุ */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Alert, Card, Flex, Input, Segmented, Table, Typography, message } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import StatusTag from "../../../components/ak/StatusTag";
import { SelectionService, apiError } from "../../../service/Ak.service";
import { formatMoney } from "../../../utils/util";

export default function SelectionAccess() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [q, setQ] = useState("");
  const [status, setStatus] = useState("ร่าง");

  useEffect(() => {
    const t = setTimeout(() => {
      setLoading(true);
      SelectionService.list({ q: q || undefined, status: status === "ทั้งหมด" ? undefined : status }, { ignoreLoading: true })
        .then((r) => setRows(r.data?.data || []))
        .catch((e) => message.error(apiError(e)))
        .finally(() => setLoading(false));
    }, 250);
    return () => clearTimeout(t);
  }, [q, status]);

  const columns = [
    { title: "เลขที่", dataIndex: "sel_code", width: 130, render: (v) => <Typography.Link onClick={() => navigate(`manage/${v}`)}>{v}</Typography.Link> },
    {
      title: "โปรเจ็กต์ / ลูกค้า",
      key: "p",
      render: (_, r) => (
        <div>
          <div>{r.project_name}</div>
          <div style={{ fontSize: 12, color: "#8c8c8c" }}>
            {r.project_code} · {[r.prename, r.cus_name].filter(Boolean).join(" ")}
          </div>
        </div>
      ),
    },
    { title: "Template", dataIndex: "tpl_name" },
    { title: "จุด", dataIndex: "item_count", align: "center", width: 70 },
    { title: "อัปเกรด", dataIndex: "upgrade_count", align: "center", width: 80 },
    { title: "ส่วนต่างรวม", dataIndex: "total_upgrade", align: "right", render: (v) => formatMoney(v, 2) },
    { title: "สถานะ", dataIndex: "status", render: (v) => <StatusTag value={v} /> },
    { title: "ล็อกเมื่อ", dataIndex: "locked_date", render: (v, r) => (v ? `${dayjs(v).format("DD/MM/YYYY")} · ${r.signer_name || ""}` : "-") },
  ];

  return (
    <Card className="ak-card">
      <Typography.Title level={3} className="m-0 !text-zinc-800">
        ใบเลือกวัสดุ
      </Typography.Title>
      <Typography.Text type="secondary">สร้างใบใหม่จากหน้ารายละเอียดโปรเจ็กต์ (ปุ่ม "เริ่มเลือกวัสดุ")</Typography.Text>
      <Flex gap={8} wrap="wrap" className="my-3">
        <Input allowClear prefix={<SearchOutlined />} placeholder="ค้นหา เลขที่ / โปรเจ็กต์ / ลูกค้า" value={q} onChange={(e) => setQ(e.target.value)} style={{ width: 320 }} />
        <Segmented value={status} onChange={setStatus} options={["ร่าง", "ล็อกสเปกแล้ว", "ยกเลิก", "ทั้งหมด"]} />
      </Flex>
      {status === "ร่าง" && rows.length > 0 && <Alert className="mb-3" type="info" showIcon message={`มี ${rows.length} ใบที่ลูกค้ายังไม่ได้ยืนยันสเปก`} />}
      <Table rowKey="sel_code" size="small" loading={loading} columns={columns} dataSource={rows} scroll={{ x: "max-content" }}
        onRow={(r) => ({ onDoubleClick: () => navigate(`manage/${r.sel_code}`) })} pagination={{ pageSize: 25 }} />
    </Card>
  );
}
